import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

async function fetchCompanyAttributes(companyId: number): Promise<string[]> {
  const { data } = await axiosInstance.get<string[]>(api.getCompanyAttributes(companyId));
  return data ?? [];
}

export function useCompanyAttributesQuery(companyId: number, enabled = true) {
  return useQuery({
    queryKey: queryKeys.company.attributes(companyId),
    queryFn: () => fetchCompanyAttributes(companyId),
    enabled: enabled && Boolean(companyId),
  });
}
